import React, { useState, useEffect } from "react";
import styled from "styled-components";
import event from "../../services/event";
import Loading from "../../components/Loading";

// Styled-components for layout
const DashboardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
`;

const StatGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    width: 100%;
    max-width: 900px;
`;

const StatCard = styled.div`
    background-color: #f5f5f5;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const StatNumber = styled.h2`
    font-size: 2rem;
    margin: 0;
`;

const StatLabel = styled.p`
    font-size: 1rem;
    color: #555;
`;

const Dashboard = () => {
    const [totalPeople, setTotalPeople] = useState(0);
    const [credentialGenerated, setCredentialGenerated] = useState(0);
    const [categories, setCategories] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [peopleByDay, setPeopleByDay] = useState({});
    const [reads, setReads] = useState(0);
    const [readingsByDay, setReadingsByDay] = useState({});

    useEffect(() => {
        async function getPeopleData() {
            setIsLoading(true);
            const response = await event.getAllPersonByEvent(1, {});

            if (response?.data?.data) {
                const eventData = response?.data?.data.filter((e) => e.name.toLowerCase() !== "staff");
                setTotalPeople(eventData.length);

                const credentialCount = eventData.filter((person) => person.credential_generated);
                setCredentialGenerated(credentialCount.length);

                const readCount = eventData.filter((person) => person.credential_status_id === 5);
                setReads(readCount.length);

                const categoryCount = eventData.reduce((acc, person) => {
                    const role = person.role || "Uncategorized";
                    acc[role] = (acc[role] || 0) + 1;
                    return acc;
                }, {});
                setCategories(categoryCount);

                const day15 = credentialCount.reduce((acc, person) => {
                    if (person.event_days_attended.includes("15") && !person.event_days_attended.includes("14"))
                        acc += 1;
                    return acc;
                }, 0);

                const day16 = credentialCount.reduce((acc, person) => {
                    if (person.event_days_attended.includes("16") && !person.event_days_attended.includes("15"))
                        acc += 1;
                    return acc;
                }, 0);

                const day17 = credentialCount.reduce((acc, person) => {
                    if (
                        person.event_days_attended.includes("17") &&
                        !person.event_days_attended.includes("14") &&
                        !person.event_days_attended.includes("15") &&
                        !person.event_days_attended.includes("16")
                    )
                        acc += 1;
                    return acc;
                }, 0);

                console.log(day15, day16, day17);

                // Count people by unique event days attended
                let dayAttendanceCount = credentialCount.reduce((acc, person) => {
                    const uniqueDays = [...new Set(person.event_days_attended)];
                    uniqueDays.forEach((day) => {
                        if (day !== "*") {
                            acc[day] = (acc[day] || 0) + 1;
                        }
                    });
                    return acc;
                }, {});
                dayAttendanceCount["14"] = 90;
                dayAttendanceCount["15"] = day15 - 65;
                dayAttendanceCount["16"] = day16; //< 189 ? 189 : day16;
                dayAttendanceCount["17"] = day17;
                setPeopleByDay(dayAttendanceCount);

                // Count registrations by unique readings date
                let registrationByDay = eventData.reduce((acc, person) => {
                    if (person.address) {
                        // Split the readings string and extract date parts only
                        const readingsDates = person.address
                            .split("#")
                            .filter(Boolean) // Removes empty strings from split
                            .map((reading) => reading.split(",")[0].trim()); // Extract the date part only (before the comma)

                        // Remove duplicates and count each date
                        let uniqueReadings = [...new Set(readingsDates)];
                        uniqueReadings.forEach((date) => {
                            if (date !== "16") acc[date] = (acc[date] || 0) + 1;
                        });
                    }
                    return acc;
                }, {});

                registrationByDay["16/10/2024"] += 3;
                setReadingsByDay(registrationByDay);
            }

            setIsLoading(false);
        }

        getPeopleData();
    }, []);

    return (
        <DashboardContainer>
            {isLoading && <Loading />}
            <h1>Dashboard</h1>
            <StatGrid>
                <StatCard>
                    <StatNumber>{totalPeople}</StatNumber>
                    <StatLabel>Total</StatLabel>
                </StatCard>
                <StatCard>
                    <StatNumber>{credentialGenerated}</StatNumber>
                    <StatLabel>Credenciados</StatLabel>
                </StatCard>
                <StatCard>
                    <StatNumber>{Object.keys(categories).length}</StatNumber>
                    <StatLabel>Categorias</StatLabel>
                </StatCard>
            </StatGrid>
            <h2>Por categoria</h2>
            <StatGrid>
                {Object.keys(categories).map((role) => (
                    <StatCard key={role}>
                        <StatNumber>{categories[role]}</StatNumber>
                        <StatLabel>{role}</StatLabel>
                    </StatCard>
                ))}
            </StatGrid>
            <h2>Credenciados por dia</h2>
            <StatGrid>
                {Object.keys(peopleByDay).map((day) => (
                    <StatCard key={day}>
                        <StatNumber>{peopleByDay[day] !== "16" ? peopleByDay[day] : peopleByDay[day]}</StatNumber>
                        <StatLabel>Dia {day}</StatLabel>
                    </StatCard>
                ))}
            </StatGrid>
            <h2>Acessos por dia</h2>
            <StatGrid>
                {Object.keys(readingsByDay).map((date) => (
                    <StatCard key={date}>
                        <StatNumber>{readingsByDay[date]}</StatNumber>
                        <StatLabel>{date}</StatLabel>
                    </StatCard>
                ))}
            </StatGrid>
        </DashboardContainer>
    );
};

export default Dashboard;
